// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-area {
  cursor: pointer;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-color: #dee2e6 !important;
}

.upload-area:hover {
  background-color: #f8f6f1 !important;
  border-color: #ffa559 !important;
}

.shadow-inner {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.recipe-content h1,
.recipe-content h2,
.recipe-content h3 {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
}

.recipe-content ul,
.recipe-content ol {
  padding-left: 1.2rem;
  margin-bottom: 1.5rem;
}

.recipe-content li {
  margin-bottom: 0.5rem;
}

.recipe-container::-webkit-scrollbar {
  width: 6px;
}
.recipe-container::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 10px;
}

.card.position-relative {
  scroll-margin-top: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/classification.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;EAGE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".upload-area {\n  cursor: pointer;\n  min-height: 250px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-color: #dee2e6 !important;\n}\n\n.upload-area:hover {\n  background-color: #f8f6f1 !important;\n  border-color: #ffa559 !important;\n}\n\n.shadow-inner {\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.recipe-content h1,\n.recipe-content h2,\n.recipe-content h3 {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #000;\n}\n\n.recipe-content ul,\n.recipe-content ol {\n  padding-left: 1.2rem;\n  margin-bottom: 1.5rem;\n}\n\n.recipe-content li {\n  margin-bottom: 0.5rem;\n}\n\n.recipe-container::-webkit-scrollbar {\n  width: 6px;\n}\n.recipe-container::-webkit-scrollbar-thumb {\n  background: #dee2e6;\n  border-radius: 10px;\n}\n\n.card.position-relative {\n  scroll-margin-top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
